import {enforce} from "vest";

export function discountPercent(value: any) {
  enforce(value).message('validator.discount_percent').inside([3, 5, 7, 10, 15, 20]);
}
